import { render, staticRenderFns } from "./SectionAttentionProcess.vue?vue&type=template&id=66bb4b85&scoped=true"
import script from "./SectionAttentionProcess.vue?vue&type=script&lang=js"
export * from "./SectionAttentionProcess.vue?vue&type=script&lang=js"
import style0 from "./SectionAttentionProcess.vue?vue&type=style&index=0&id=66bb4b85&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66bb4b85",
  null
  
)

export default component.exports